import { startLoading, stopLoading } from "@slices/loader.slice";
import { store } from "@store";
import axios from "axios";
import { ApplicationResponse } from "../domain/common.model";
import { showErrorToast, showSuccessToast } from "@utils/toast.utils";
import { logout } from "@src/redux/slices/auth.slice";

const api = axios.create({});

api.interceptors.request.use(
  (config) => {
    store.dispatch(startLoading());
    return config;
  },
  (error) => {
    store.dispatch(stopLoading());
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    store.dispatch(stopLoading());
    const params = response.config.params;
    const data = response.data as ApplicationResponse<any>;
    if(response.status === Number.parseInt('403')){
       showErrorToast("You are not authorized to perform this action.");
      store.dispatch(logout());
      window.location.reload();
    }
    if(response.status === Number.parseInt('401')){
        showErrorToast("You are not authorized to perform this action. Please contact your administrator.");
        store.dispatch(logout());
        window.location.reload();
    }

    if (
      data.status === "RESOURCE_CREATED" ||
      data.status === "RESOURCE_UPDATED" ||
      data.status === "RESOURCE_DELETED"
    ) {
      showSuccessToast(data.message);
      if (params?.RAR !== 0) { //TODO - Make changes in this so that window do not reload if there is no parameter named RAR.
        window.location.reload();
      }
    }
    if (data.status === "ERROR") {
      showErrorToast(data.message);
    }
    return response;
  },
  (error) => {
    store.dispatch(stopLoading());
    return Promise.reject(error);
  }
);

export const setupAxiosInterceptors = (store: any) => {
  api.interceptors.request.use(
    (config) => {
      const state = store.getState();
      const token = state.auth.token.data; // Assuming this is where your token is stored

      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
      }

      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
};

export default api;
